module.exports = __webpack_public_path__ + "img/greenn50.4aaaa70e.png";